import React, { useState, useEffect } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Users } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { AutoBIMLogo, Wordmark } from "@/components/Brand";
import { Button, Card, Input, Spinner } from "@/components/ui";

export default function FirmJoin() {
  const { user, lang, loading } = useAuth();
  const isAr = lang === "ar";
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [token, setToken] = useState(params.get("token") || "");
  const [busy, setBusy] = useState(false);

  useEffect(() => { const t = params.get("token"); if (t) setToken(t); }, [params]);

  async function join() {
    if (!token) return;
    setBusy(true);
    try {
      await api.acceptFirmInvite(token.trim());
      toast.success(isAr ? "تم الانضمام إلى المكتب" : "Joined the firm");
      navigate("/firm");
    } catch (e) {
      toast.error(String(e.message || e));
    } finally {
      setBusy(false);
    }
  }

  if (loading) return <div className="grid h-screen place-items-center"><Spinner size={36} className="text-primary" /></div>;

  return (
    <div className="min-h-screen abl-grid-bg">
      <header className="flex items-center justify-between border-b border-border bg-background/85 px-5 py-3 backdrop-blur">
        <Link to="/" className="flex items-center gap-2.5"><AutoBIMLogo size={30} /><Wordmark small /></Link>
      </header>
      <div className="mx-auto max-w-md px-5 py-16">
        <Card className="text-center">
          <div className="mx-auto mb-4 grid h-14 w-14 place-items-center rounded-2xl bg-primary/15"><Users className="text-primary" size={28} /></div>
          <h1 className="text-xl font-black">{isAr ? "انضمام إلى مكتب هندسي" : "Join an engineering firm"}</h1>
          <p className="mt-2 text-sm text-muted-foreground">{isAr ? "أدخل رمز الدعوة الذي استلمته من مدير المكتب." : "Enter the invitation token you received from the firm admin."}</p>
          {!user ? (
            <div className="mt-5 space-y-2">
              <p className="text-sm text-amber-400">{isAr ? "سجّل الدخول أولاً لقبول الدعوة" : "Sign in first to accept the invite"}</p>
              <Link to="/login"><Button className="w-full">{isAr ? "تسجيل الدخول" : "Sign in"}</Button></Link>
            </div>
          ) : (
            <div className="mt-5 space-y-3">
              <Input value={token} onChange={(e) => setToken(e.target.value)} placeholder={isAr ? "رمز الدعوة" : "Invitation token"} data-testid="firm-join-token" />
              <Button className="w-full" loading={busy} onClick={join} data-testid="firm-join-btn">{isAr ? "انضمام" : "Join firm"}</Button>
            </div>
          )}
        </Card>
      </div>
    </div>
  );
}
